import * as React from 'react'
import { useStaticQuery, graphql } from "gatsby"
import { Link } from 'gatsby'
import Nav from 'react-bootstrap/Nav'
import Navbar from 'react-bootstrap/Navbar'
import Container from 'react-bootstrap/Container'
import '../styles/nav.scss'
import useStickyNav from '../hooks/useStickyNav'
import { HiOutlineMenu } from "react-icons/hi"

const Navigation = () => {
    const data = useStaticQuery(graphql`
        query NavQuery {
            imbLogo: contentfulAsset(contentful_id: {eq: "7tsXZSBxJtxSSx6QvPjID4"}) {
                file{
                    url
                }
            }
        }
    `)
    
    const { isSticky, navRef, toggleNav, navVisible } = useStickyNav()

    return (
        <Navbar id="nav" expand="xl" className={`p-3 bg-white bottomBorder topBorder ${isSticky ? 'fixed-top' : ''}`} ref={navRef}>
            <Container className='align-items-center'>
                <Navbar.Brand as={Link} to="/"className='m-0 p-0'>
                    <img src={data.imbLogo.file.url} height={50} className='d-none d-xl-block' alt="" />
                    <img src={data.imbLogo.file.url} width={200} className='d-block d-xl-none' alt="" />
                </Navbar.Brand>

                <Navbar.Toggle aria-controls="basic-navbar-nav" className="p-0 border-0" onClick={toggleNav}>
                    <HiOutlineMenu color="gray" size="2rem" />
                </Navbar.Toggle>

                <Navbar.Collapse id="basic-navbar-nav" className={`${navVisible ? 'show' : ''} justify-content-end`}>
                    <Nav className='align-items-center'>
                        
                        <Nav.Link as={Link} to="/about">About</Nav.Link>
                        <Nav.Link as={Link} to="/careers">Careers</Nav.Link>
                        <a className='nav-link' href="https://support.inmusicstore.com/en/support/tickets/new" target='_blank' rel="noreferrer">Contact Us</a>
                        
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    )
}

export default Navigation
